import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), 'ViewHeadlineSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewHeadlineSharp.js
// module id = 7103
// module chunks = 2